import React, {lazy, Suspense} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import siteConfig from './config/siteConfig';
import {useAnalytics} from './hooks/useAnalytics';
import {LanguageProvider} from './context/LanguageContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CookieBanner from './components/ui/CookieBanner';

// Lazy-load section components
const Hero        = lazy(() => import('./components/sections/Hero'));
const Problem     = lazy(() => import('./components/sections/Problem'));
const About       = lazy(() => import('./components/sections/About'));
const Methodology = lazy(() => import('./components/sections/Methodology'));
const Services    = lazy(() => import('./components/sections/Services'));
const Results     = lazy(() => import('./components/sections/Results'));
const LeadCapture = lazy(() => import('./components/sections/LeadCapture'));
const FAQ         = lazy(() => import('./components/sections/FAQ'));
const WhyNow      = lazy(() => import('./components/sections/WhyNow'));
const Podcast     = lazy(() => import('./components/sections/Podcast'));

// Lazy-load legal pages
const PrivacyPolicy  = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

// Event modal
const EventModal = lazy(() => import('./components/ui/EventModal'));

const SECTION_MAP = {
  hero:        Hero,
  problem:     Problem,
  about:       About,
  methodology: Methodology,
  services:    Services,
  results:     Results,
  leadCapture: LeadCapture,
  podcast:     Podcast,
  faq:         FAQ,
  whyNow:      WhyNow,
};

function LandingPage() {
  const enabledSections = Object.entries(siteConfig.sections)
    .filter(([, cfg]) => cfg.enabled)
    .sort(([, a], [, b]) => a.order - b.order)
    .map(([key]) => key);

  return (
    <>
      <Navbar />
      <main id="main">
        {enabledSections.map((key) => {
          const Section = SECTION_MAP[key];
          return Section ? <Section key={key} /> : null;
        })}
      </main>
      <Footer />
      {siteConfig.features.cookieConsent && <CookieBanner />}
      {siteConfig.features.eventModal && <EventModal />}
    </>
  );
}

function App() {
  useAnalytics();

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={<div style={{minHeight: '100vh', background: '#ffffff'}} />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
            <Route path="/terms" element={<><Navbar /><TermsOfService /><Footer /></>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
